<template>
  <div>

    <AuthHeader/>

    <main class="inner-page__content  align-items-stretch  p-0">
      <div class="exam  w-100">
        <div class="exam__content">

          <h1 class="exam__page-title  pt-3">{{ getTranslation('identification') }}</h1>

          <div class="exam__identification">

            <div class="exam__data-group">
              <label class="exam__data-label" for="personPin">1. {{ getTranslation('yourPin') }}</label>

              <div class="d-flex">
                <div class="exam__identification-field">
                  <input class="field  field--full-width" maxlength="14" autocomplete="off" v-model.trim="pin" type="text" id="personPin" :class="{'field--error' : $v.pin.$error}">
                </div>
                <div class="exam__data-descr  m-0  pl-3  w-50">{{ getTranslation('yourPinExample') }}</div>
              </div>
            </div>

            <div class="exam__data-group">
              <label class="exam__data-label" for="personPin">2. {{ getTranslation('yourPhoto') }}</label>

              <div class="d-flex">

                <video ref="video" class="exam__identification-photo photo-capture" id="video" autoplay/>

                <canvas ref="canvas" id="canvas" height="210" width="210"/>

                <div class="exam__data-descr  m-0  pl-3">
                  {{ getTranslation('identificationExample') }}
                  <div class="color-accent  pt-3">
                    {{ getTranslation("can'tIdentify") }} {{ getTranslation('you can sign in via') }}
                    <a @click="gotoLoginPage" href="javascript:void(0)">{{ getTranslation('loginAndPassword') }}</a>
                    .
                    {{ getTranslation('inquireAdmin') }}
                  </div>
                </div>

              </div>
            </div>

          </div>

          <div class="exam__page-actions">
            <a v-if="isStreaming" class="btn  btn--main" @click="startIdentification" href="javascript:void(0)">{{ getTranslation('startIdentification') }}</a>
            <a v-if="!isStreaming && captureLength < 3 && !showLoginForm" class="btn  btn--info" @click="play" href="javascript:void(0)">{{ getTranslation('turnOnCamera') }}</a>
            <a v-if="!isStreaming && captureLength < 3 && showLoginForm" class="btn  btn--info" @click="showLogin(false)" href="javascript:void(0)">{{ getTranslation('faceIdentification') }}</a>
            <a v-if="isStreaming" class="btn  btn--accent-outline" @click="stop" href="javascript:void(0)">{{ getTranslation('stopIdentification') }}</a>
          </div>

        </div>
      </div>
    </main>
    <Footer/>
  </div>
</template>

<script>
import Footer from "../layouts/Footer";
import required from "vuelidate/lib/validators/required";
import AuthHeader from "./components/AuthHeader";

export default {
  name: "Index",
  components: {AuthHeader, Footer},
  data() {
    return {
      pin: '',
      photo: '',
      password: '',
      video: {},
      canvas: {},
      captures: [],
      isAuthorized: false,
      isStreaming: false,
      showLoginForm: false,
    }
  },
  mounted() {
    if (this.$route.name === 'auth.identification') {
      this.video = this.$refs.video;
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;
      if (navigator.mediaDevices) {
        navigator.mediaDevices.getUserMedia({video: true}).then(stream => {
          this.video.srcObject = stream;
          this.video.play();
          this.isStreaming = true;
        }).catch(() => {
          if (this.$route.name === 'auth.identification')
            this.snotifyError('NotAllowedError');
          else
            this.$router.push({name: 'auth.identification'}).catch(() => {
            });
        });
      } else {
        this.snotifyWarning('checkYourCamera');
      }
    }
  },
  updated() {
    this.setHeadings({
      title: this.getTranslation('identification')
    });
  },
  computed: {
    captureLength() {
      return this.captures.length;
    },
  },
  methods: {
    async gotoLoginPage() {
      await this.stop();
      this.$router.push({name: 'auth.login'}).catch(() => {
      });
    },
    startIdentification() {
      if (this.captureLength < 3) {

        this.$v.pin.$touch();

        if (this.$v.pin.$invalid)
          return this.snotifyError('wrongFormMsg');

        this.canvas = this.$refs.canvas;

        let context = this.canvas.getContext("2d").drawImage(this.video, 0, 0, 210, 210);

        this.photo = canvas.toDataURL("image/jpeg", 0.8).replace('data:image/jpeg;base64,', '');

        this.axios.post(this.$config.urls.candidateAuth.identification.url, {pin: this.pin, photo: this.photo, lang: this.currentLocale})
            .then(response => {
              this.stop();
              this.setCandidateToken(response.data.data.token);
              this.setCandidateAxiosHeader();

              this.storeCandidate(response.data.data).then(() => {
                this.$router.push({name: 'auth.success'}).catch(() => {
                });
              });
            }).catch(() => {

          this.captures.push(canvas.toDataURL("image/png", 0.8));

          if (this.captureLength === 3)
            this.$snotify.error(this.getTranslation('askAdmin') + ', ' + this.getTranslation('notIdentified'), {
              timeout: 7000,
              pauseOnHover: true
            });
        });

      } else {
        this.$snotify.error(this.getTranslation('askAdmin') + ', ' + this.getTranslation('notIdentified'), {
          timeout: 7000,
          pauseOnHover: true
        });
      }
    },
    play() {
      this.video = this.$refs.video;
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;
      if (navigator.mediaDevices) {
        navigator.mediaDevices.getUserMedia({video: true}).then(stream => {
          this.video.srcObject = stream;
          this.video.play();
          this.isStreaming = true;
        }).catch(() => {
          this.snotifyError('NotAllowedError');
        });
      } else {
        this.snotifyWarning('checkYourCamera');
      }
    },
    stop() {
      if (this.video && this.video.srcObject)
        this.video.srcObject.getTracks().forEach(track => {
          track.stop();
        });
      this.isStreaming = false;
    },
    clear() {
      this.captures = [];
    }
  },
  validations: {
    pin: {
      required
    },
    password: {
      required
    },
  }
}
</script>

<style scoped>
#canvas {
  display: none;
}
</style>
